"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PimTablePage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var bulk_update_product_1 = require("../../../../../api/calls/product/bulk_update_product");
var tabel_cell_1 = require("../../../../../components/tabel_cell");
var table_bottom_content_1 = require("../../../../../components/table/tableBottomContent/table_bottom_content");
var tableContext_1 = require("../../../../../contexts/tableContext");
var get_categories_thunk_1 = require("../../../../../reducers/slices/categories/thunks/get_categories_thunk");
var main_1 = require("../../../../../reducers/slices/main");
var product_1 = require("../../../../../reducers/slices/products/product");
var get_product_attributes_thunk_1 = require("../../../../../reducers/slices/products/product_attribute/thunks/get_product_attributes_thunk");
var get_products_shopify_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_products_shopify_thunk");
var table_grid_1 = require("./components/components/table_grid");
var pim_products_filter_1 = __importDefault(require("./components/pim_products_filter/pim_products_filter"));
var pim_table_top_bar_1 = require("./components/pim_table_top_bar");
var pim_bulk_edit_preview_1 = __importDefault(require("./components/pim_table_top_content/components/pim_table_top_content/pim_bulk_edit_preview"));
var useColumns_1 = require("./hooks/useColumns");
var useFilterActions_1 = require("./hooks/useFilterActions");
var useRenderCellEditViews_1 = require("./hooks/useRenderCellEditViews");
var useRenderCellViews_1 = require("./hooks/useRenderCellViews");
var useRowActions_1 = require("./hooks/useRowActions");
var product_list_1 = require("../../../../../api/calls/product/product_list");
var pim_table_top_content_1 = require("./components/pim_table_top_content/pim_table_top_content");
var constants_1 = require("./constants");
var react_3 = require("@csvbox/react");
var react_4 = require("@iconify/react");
var PimTablePage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.productState; }), products = _a.products, pagination = _a.pagination, loading = _a.loading;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeState; }), productAttributes = _b.productAttributes, productAttributesPagination = _b.pagination;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }), categories = _c.categories, categoriesPagination = _c.pagination;
    var client_token = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).client_token;
    var _d = (0, react_1.useState)(), maxFilterPrice = _d[0], setMaxFilterPrice = _d[1];
    var _e = (0, react_1.useState)(false), isTableEditEnabled = _e[0], setIsTableEditEnabled = _e[1];
    var _f = (0, react_1.useState)([]), modifiedProducts = _f[0], setModifiedProducts = _f[1];
    var _g = (0, react_1.useState)([]), bulkEditPayload = _g[0], setBulkPayload = _g[1];
    var _h = (0, react_1.useState)([]), filteredProducts = _h[0], setFilteredProducts = _h[1];
    var filterActions = (0, useFilterActions_1.useFilterActions)({ products: products, productAttributes: productAttributes, categories: categories, maxFilterPrice: maxFilterPrice }).filterActions;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _j = (0, react_1.useState)(false), canImport = _j[0], setCanImport = _j[1];
    var _k = (0, react_1.useState)(constants_1.LayoutType.LIST), tableLayout = _k[0], setTableLayout = _k[1];
    var _l = (0, useRowActions_1.useRowActions)(), rowActions = _l.rowActions, onSelectionChange = _l.onSelectionChange, selectedTableCells = _l.selectedTableCells;
    var renderCellViews = (0, useRenderCellViews_1.useRenderCellViews)().renderCellViews;
    var renderCellVEditViews = (0, useRenderCellEditViews_1.useRenderCellEditViews)().renderCellVEditViews;
    var _m = (0, useColumns_1.useColumns)(), columns = _m.columns, excludeSortColumns = _m.excludeSortColumns, headerColumns = _m.headerColumns, initialSortDescriptor = _m.initialSortDescriptor, onVisibleColumnsChanged = _m.onVisibleColumnsChanged, setTableColumnConfig = _m.setTableColumnConfig, tableColumnConfig = _m.tableColumnConfig, visibleColumns = _m.visibleColumns;
    var previewBulkEdit = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Preview Changes",
            content: (0, jsx_runtime_1.jsx)(pim_bulk_edit_preview_1.default, { bulkEditPayload: bulkEditPayload, setBulkEditPayload: setBulkPayload }),
        }));
    };
    var onLayoutChanged = (0, react_1.useCallback)(function (layout) {
        setTableLayout(layout);
    }, []);
    var getProducts = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_products_shopify_thunk_1.get_products_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var getAllProducts = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _b, _c, _d;
        var page = _a.page, size = _a.size, countTotal = _a.countTotal, query = __rest(_a, ["page", "size", "countTotal"]);
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (countTotal === 0)
                        return [2 /*return*/];
                    if (!isTableEditEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, product_list_1.get_product_list)(__assign({ page: 1, size: countTotal }, query))];
                case 1:
                    response = _e.sent();
                    if (response.success) {
                        onSelectionChange("all", (_b = response.content) === null || _b === void 0 ? void 0 : _b.product_list);
                        setFilteredProducts((_c = response.content) === null || _c === void 0 ? void 0 : _c.product_list);
                        setModifiedProducts((_d = response.content) === null || _d === void 0 ? void 0 : _d.product_list);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    getProducts(__assign({}, pagination));
                    _e.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getProductAttributes = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_product_attributes_thunk_1.get_product_attributes_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var getCategories = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_categories_thunk_1.get_categories_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var handleSetModifiedProducts = (0, react_1.useCallback)(function (_a) {
        var key = _a.key, value = _a.value, id = _a.id;
        var changes = bulkEditPayload;
        var bulkIndex = changes === null || changes === void 0 ? void 0 : changes.findIndex(function (item) { return item._id === id; });
        setModifiedProducts(function (prev) {
            var baseProducts = prev;
            var updatedProducts = baseProducts.map(function (item, idx) {
                var _a, _b;
                if (item._id === id) {
                    if (constants_1.EDITABLE_FIELD_KEYS.includes(key)) {
                        var updatedChange = (_a = { _id: id }, _a[key] = value, _a);
                        if (bulkIndex !== -1) {
                            changes[bulkIndex] = __assign(__assign({}, changes[bulkIndex]), updatedChange);
                        }
                        else
                            changes.push(updatedChange);
                    }
                    return __assign(__assign({}, item), (_b = {}, _b[key] = value, _b));
                }
                return item;
            });
            return updatedProducts;
        });
        setBulkPayload(changes);
    }, [modifiedProducts, filteredProducts]);
    var onSaveBulkEdit = function (scheduleTime) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scheduleTime = typeof scheduleTime === "string" ? scheduleTime : undefined;
                    return [4 /*yield*/, (0, bulk_update_product_1.bulk_update_products)({ products: bulkEditPayload, schedule_time: scheduleTime })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        dispatch((0, main_1.setMessageModal)({ title: "Success", messages: [response.message] }));
                        getProducts(__assign({}, pagination));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [response.message] }));
                    }
                    setIsTableEditEnabled(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var drawerContent = (0, jsx_runtime_1.jsx)(pim_products_filter_1.default, { showActions: false, title: "Products" });
    var handleImportComplete = (0, react_1.useCallback)(function (result, data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); }, [dispatch, pagination]);
    var onReadyChanged = (0, react_1.useCallback)(function () {
        setCanImport(true);
    }, []);
    var importButton = user.role === "ADMIN" ? ((0, jsx_runtime_1.jsx)(react_3.CSVBoxButton, __assign({ licenseKey: process.env.CSVBOX_KEY, user: { user_id: "default123" }, onImport: handleImportComplete, onReady: onReadyChanged }, { children: !!canImport ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-2 rounded-xl bg-primary px-4 py-2.5 text-white" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "text-sm" }, { children: "Import Products" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "my-auto" }, { children: (0, jsx_runtime_1.jsx)(react_4.Icon, { className: "my-auto", icon: "material-symbols:csv", width: "20", height: "20" }) }))] }))) : ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", isDisabled: true, isLoading: true }, { children: "Import Products" }))) }))) : null;
    var renderRowView = (0, react_1.useCallback)(function (id) {
        var enableEditView = isTableEditEnabled && (selectedTableCells === null || selectedTableCells === void 0 ? void 0 : selectedTableCells.has) && ((selectedTableCells === null || selectedTableCells === void 0 ? void 0 : selectedTableCells.has(id)) || (selectedTableCells === null || selectedTableCells === void 0 ? void 0 : selectedTableCells.has("all")) || (selectedTableCells === null || selectedTableCells === void 0 ? void 0 : selectedTableCells.size) === 0);
        return enableEditView ? renderCellVEditViews : renderCellViews;
    }, [isTableEditEnabled, selectedTableCells]);
    (0, react_1.useEffect)(function () {
        getAllProducts(__assign({}, pagination));
    }, [isTableEditEnabled]);
    (0, react_1.useEffect)(function () {
        var sc = Array.from(selectedTableCells);
        var isAllSelected = sc.join("") === "all" || sc.length === 0;
        if ((sc && sc.length > 0) || isAllSelected) {
            var prod = products === null || products === void 0 ? void 0 : products.find(function (p) { return (p === null || p === void 0 ? void 0 : p._id) === sc[sc.length - 1]; });
            dispatch((0, product_1.updateSelectedProducts)(prod));
        }
        else {
            dispatch((0, product_1.setSelectedProducts)([]));
        }
    }, [selectedTableCells, isTableEditEnabled]);
    (0, react_1.useEffect)(function () {
        if (client_token && !loading) {
            getProductAttributes(__assign({}, productAttributesPagination));
            //TODO: implement paginated dropdown then remove size prop
            getCategories(__assign(__assign({}, categoriesPagination), { size: 100 }));
        }
    }, [client_token]);
    (0, react_1.useEffect)(function () {
        if (!!products) {
            setModifiedProducts(products);
        }
    }, [products]);
    return ((0, jsx_runtime_1.jsx)(tableContext_1.TableContextProvider, __assign({ columns: columns, defaultQueryParams: pagination, excludeSortColumns: excludeSortColumns, filterActions: filterActions, headerColumns: headerColumns, initialSortDescriptor: initialSortDescriptor, onPageChange: getProducts, onVisibleColumnsChanged: onVisibleColumnsChanged, setTableConfig: setTableColumnConfig, tableColumnConfig: tableColumnConfig, pagination: pagination, visibleColumns: visibleColumns, drawerContent: drawerContent, onLayoutChanged: onLayoutChanged }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col" }, { children: [(0, jsx_runtime_1.jsx)(pim_table_top_bar_1.TableTopBar, { customActions: [importButton] }), tableLayout === constants_1.LayoutType.GRID ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(pim_table_top_content_1.TableTopContent, { previewBulkEdit: previewBulkEdit, selectedTableCells: selectedTableCells, isTableEditEnabled: isTableEditEnabled, enableBulkEdit: function () {
                                setIsTableEditEnabled(!isTableEditEnabled);
                            }, bulkEditPayload: bulkEditPayload, onSaveBulkEdit: onSaveBulkEdit, handleSetModifiedProducts: handleSetModifiedProducts, onLayoutChanged: onLayoutChanged }), (0, jsx_runtime_1.jsx)(table_grid_1.TableGridComponent, { modifiedProducts: modifiedProducts, headerColumns: headerColumns, renderRowView: renderRowView, handleSetModifiedProducts: handleSetModifiedProducts }), (0, jsx_runtime_1.jsx)(table_bottom_content_1.TableBottomContent, {})] })) : ((0, jsx_runtime_1.jsxs)(react_2.Table, __assign({ isHeaderSticky: true, "aria-label": "Products", bottomContent: (0, jsx_runtime_1.jsx)(table_bottom_content_1.TableBottomContent, {}), bottomContentPlacement: "outside", classNames: {
                        td: "before:bg-transparent",
                    }, className: "overflow-hidden", selectedKeys: selectedTableCells, selectionMode: isTableEditEnabled ? "none" : "multiple", sortDescriptor: initialSortDescriptor, topContent: (0, jsx_runtime_1.jsx)(pim_table_top_content_1.TableTopContent, { selectedTableCells: selectedTableCells, isTableEditEnabled: isTableEditEnabled, enableBulkEdit: function () {
                            setIsTableEditEnabled(!isTableEditEnabled);
                        }, bulkEditPayload: bulkEditPayload, onSaveBulkEdit: onSaveBulkEdit, handleSetModifiedProducts: handleSetModifiedProducts, onLayoutChanged: onLayoutChanged, previewBulkEdit: previewBulkEdit }), topContentPlacement: "outside", onSelectionChange: onSelectionChange }, { children: [(0, jsx_runtime_1.jsx)(react_2.TableHeader, __assign({ columns: headerColumns }, { children: function (column) { return ((0, jsx_runtime_1.jsx)(react_2.TableColumn, __assign({ align: column.uid === "actions" ? "end" : "start", className: (0, react_2.cn)([column.uid === "actions" ? "flex items-center justify-end px-[20px]" : ""]) }, { children: column.name }), column.uid)); } })), (0, jsx_runtime_1.jsx)(react_2.TableBody, __assign({ isLoading: loading, emptyContent: "This table is empty.", items: modifiedProducts, loadingContent: (0, jsx_runtime_1.jsx)(react_2.Spinner, { label: "Loading..." }) }, { children: function (item) {
                                return ((0, jsx_runtime_1.jsx)(react_2.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_2.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: item, columnKey: columnKey, renderCellViews: renderRowView(item === null || item === void 0 ? void 0 : item._id), rowActions: rowActions, setModifiedRecords: handleSetModifiedProducts }) })); } }, item === null || item === void 0 ? void 0 : item._id));
                            } }))] })))] })) })));
};
exports.PimTablePage = PimTablePage;
